import { Log, UserManager } from 'oidc-client-ts'

const development =
  process.env.NODE_ENV === undefined || process.env.NODE_ENV !== 'production'

// we need this because prod is mounted on '/ui' due to legacy weblogic development
// and we don't want to reconfigure multiple  call back urls with idp
const callBackBase = development ? '/ui' : ''
export const signinCallbackPath = `${callBackBase}/signin-callback`
export const signoutCallbackPath = `${callBackBase}/signout-callback`

export const getMetaConfig = (metaName, defaultValue) => {
  if (window == null || window.document == null) return null
  const metaData = window.document.getElementsByTagName('meta')
  for (let i = 0; i < metaData.length; i++) {
    if (metaData[i].getAttribute('name') === metaName) {
      const value = metaData[i].getAttribute('content')
      return value == null || value.trim().length === 0 ? defaultValue : value
    }
  }
  return defaultValue
}

// const oktaAuthProps = {
//   stsAuthority: getMetaConfig(
//     'stsAuthority',
//     'https://dominionenergy.okta.com'
//   ),
//   clientId: getMetaConfig('oidcClientId', '0oa1lpyhpqpVACvjC1d8'),
//   clientRoot: getMetaConfig(
//     'oidcClientRootUrl',
//     'https://dom-dev-pmgr.integportal.com'
//   ),
//   clientScope: getMetaConfig('oidcClientScope', 'openid profile email'),
//   clientSecret: getMetaConfig(
//     'oidcClientSecret' //,'yd6wprkZLEslLnlyZpqkjpHckcELbZh6'
//   ),
// }

const keycloakAuthProps = {
  stsAuthority: getMetaConfig('stsAuthority', 'https://sso-t.aps.com'),
  clientId: getMetaConfig('oidcClientId', 'dom-mock'),
  clientRoot: getMetaConfig('oidcClientRootUrl', 'http://localhost:3000'),
  clientScope: getMetaConfig('oidcClientScope', 'openid profile email'),
  clientSecret: getMetaConfig('oidcClientSecret'),
}

const prodAuthProps = {
  stsAuthority: getMetaConfig('stsAuthority'),
  clientId: getMetaConfig('oidcClientId'), //, '0oa1lpyhpqpVACvjC1d8'),
  clientRoot: getMetaConfig('oidcClientRootUrl'),
  clientScope: getMetaConfig('oidcClientScope', 'openid profile email'),
  clientSecret: getMetaConfig('oidcClientSecret'),
}
const debugWithKeycloak = false

// const apsAuthProps = {
//   stsAuthority: getMetaConfig('stsAuthority', 'https://sso-t.aps.com'),
//   clientId: getMetaConfig('oidcClientId', 'GMISQA'),
//   clientRoot: getMetaConfig('oidcClientRootUrl', 'http://localhost:3000'),
//   clientScope: getMetaConfig('oidcClientScope', 'openid profile email'),
//   clientSecret: getMetaConfig('oidcClientSecret'),
// }

const authProps = debugWithKeycloak ? keycloakAuthProps : prodAuthProps
const oidcEnabled =
  authProps.stsAuthority != null && authProps.stsAuthority.trim().length > 0

console.log('oidcEnabled', oidcEnabled)

const settings = {
  authority: authProps.stsAuthority,
  client_id: authProps.clientId,
  client_secret: authProps.clientSecret,
  redirect_uri: `${authProps.clientRoot}${signinCallbackPath}`,
  silent_redirect_uri: `${authProps.clientRoot}${signinCallbackPath}`,
  post_logout_redirect_uri: `${authProps.clientRoot}${signoutCallbackPath}`,
  response_type: 'code',
  scope: authProps.clientScope,
  response_mode: 'query',
}

export const userManager = oidcEnabled ? new UserManager(settings) : null

Log.logger = console
Log.level = Log.DEBUG
